<rask-saved-search-filter-tabs (filterChanged)="onFilterChanged($event)" [webbinstallningarKey]="webbInstallningarSparadeKey"></rask-saved-search-filter-tabs>
@if (form) {
  <form [formGroup]="form" (ngSubmit)="onSearch()">
    <div class="row">
      <rask-multi-selector
        class="col-2"
        label="Leverantör"
        [items]="leverantorList" bindLabel="namn"
        [searchFn]="leverantorSearchFn"
        [selected]="form.value.leverantorer"
        formControlName="leverantorer">
      </rask-multi-selector>
      <rask-multi-selector
        class="col-2"
        label="Status"
        [items]="statusList" bindLabel="namn"
        [searchFn]="statusSearchFn"
        [selected]="form.value.statusar"
        formControlName="statusar">
      </rask-multi-selector>
      <rask-input
        class="col-2"
        label="Extern Beteckning"
        formControlName="externBeteckning">
      </rask-input>
      <rask-datepicker
        class="col-2"
        label="Mottagen, Datum"
        formControlName="datumMottagen">
      </rask-datepicker>
      <rask-datepicker
        class="col-2"
        label="Uppdaterad, Datum"
        formControlName="datumUppdaterad">
      </rask-datepicker>
      <rask-save-search-filter class="col-2"
        [filterData]="model"
        [webbinstallningarKey]="webbInstallningarSparadeKey"
      [maxSavedFilters]="9"></rask-save-search-filter>
    </div>
    <div class="row">
      <div class="col-3 mt-3 ms-auto">
        <rask-submit-button
          aid="buttonExternavirkeskopSok"
          color="secondary">Sök
        </rask-submit-button>
        <rask-button
          aid="buttonExternavirkeskopRensa"
          (click)="rensaSokFilter()"
          negative
          color="secondary">
          Rensa
        </rask-button>
      </div>
    </div>
  </form>
}

